import { LayoutDashboard } from "lucide-react";
import type { INavItem } from "@/models/INavItem";
import { DashboardRoutes } from "./routes";
import { DashboardPermissions } from "./permissions";

export const dashboardNav: INavItem = {
  labelKey: "nav.dashboard",
  icon: LayoutDashboard,
  path: DashboardRoutes.INDEX,
  permissions: [DashboardPermissions.READ],
};
